export default __webpack_public_path__ + "static/media/logo.238b37f9.png";